var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#203146"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "#5A6576"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 39.0625L23.75 41.1875L34.9062 30.0312L23.75 18.875L21.625 21L29.0667 28.4417H12.0625V31.6292H29.0583L21.625 39.0625Z",
    fill: "#8C9EBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2188 30.0312L31.1875 39.0625L33.3125 41.1875L44.4688 30.0312L33.3125 18.875L31.1875 21L40.2188 30.0312Z",
    fill: "#8C9EBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circle-arrow.4a01aadb7cad21bd7b504e308f45d91d.svg";
export { ForwardRef as ReactComponent };